function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaxIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "\\u0421\\u043B\\u043E\\u0439_1",
  viewBox: "0 0 38 38"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 0c10.5 0 19 8.5 19 19s-8.5 19-19 19S0 29.5 0 19 8.5 0 19 0",
  style: {
    fill: "#7a8090"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.7 9c-6 .3-9.9 5-9.7 10.9.1 2.6 1.1 4.8 1.4 7.3 0 .6-.1 1.4.6 1.7.9.3 2.3-.2 3-.8.3-.2.5-.4.7-.6.8.5 1.5 1 2.5 1.2 4.1 1 8.6-1.3 10.6-4.9C31.5 17 26.5 8.6 18.7 9m-2.4 14.2c-.3.3-.6.6-1 .8-.5.3-.7 0-.9-.5-.6-1.5-.7-3.9-.3-5.5.5-2.1 2.1-3.9 4.3-4.1s4.3.9 5.2 3c2.1 4.6-3.2 9-7.3 6.3",
  style: {
    fill: "#fff"
  }
}));
export default SvgMaxIcon;